import {
    ChangeDetectionStrategy,
    Component,
    Injectable,
    Input,
    ViewEncapsulation,
} from '@angular/core';
import { licensedFilterList } from '@components/shared/license/license.constants';
import {
    enumMapper,
    ILicenseFrontOffice,
    LicenseFrontOfficeSource,
    ODataResponse,
    RobotType,
} from '@models';
import {
    encodeFilters,
    GRID_SERVICE,
    IGridSource,
    ODataGridComponent,
    STATE_HANDLER,
    urlStateHandler,
} from '@pages/generics/grid';
import {
    LicenseUrlMapFrontOffice,
    NamedUserLicenseService,
    ODataQueryOptions,
} from '@services';
import { IGridDataEntry } from '@uipath/angular/components/ui-grid';

import { map } from 'rxjs/operators';

type ITrackedFrontOffice = IGridDataEntry & ILicenseFrontOffice;

@Injectable()
export class FrontOfficeSource implements IGridSource<ODataQueryOptions, ODataResponse<ITrackedFrontOffice>> {
    public licenseType!: LicenseUrlMapFrontOffice;

    public get mapper() {
        return this._namedUserLicense.mapper;
    }

    constructor(
        private _namedUserLicense: NamedUserLicenseService,
    ) { }

    public get(qo: ODataQueryOptions) {
        return this._namedUserLicense.getLicenseDetails(this.licenseType, qo)
            .pipe(
                map(res => ({
                    data: res.data.map(license => ({
                        ...license,
                        id: license.key,
                    })),
                    total: res.total,
                })),
            );
    }
}

// FIXME: expose these from a common source
const ROBOT_TYPES = enumMapper(RobotType, {
    resourceKey: 'RobotType',
});

@Component({
    selector: 'ui-named-license',
    templateUrl: './named-license.grid.html',
    styleUrls: ['./../license.details.scss'],
    providers: [
        NamedUserLicenseService,
        {
            provide: GRID_SERVICE,
            useClass: FrontOfficeSource,
        },
        {
            provide: STATE_HANDLER,
            useValue: urlStateHandler,
        },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class NamedLicenseComponent
    extends ODataGridComponent<ITrackedFrontOffice, number> {
    public readonly LicenseFrontOfficeSource = LicenseFrontOfficeSource;
    public readonly licenseSourceList = enumMapper(LicenseFrontOfficeSource, {
        resourceKey: 'LicenseSource',
    }).map(source => ({
        ...source,
        value: Number(source.value) === LicenseFrontOfficeSource.Local,
    }));
    public get isLicenseTypeAttended() { return LicenseUrlMapFrontOffice.attended === this._licenseType; }


    @Input()
    public get licenseType() {
        return this._licenseType;
    }
    public set licenseType(value: LicenseUrlMapFrontOffice) {
        this._licenseType = value;
        const svc = (this._service as unknown as FrontOfficeSource);
        svc.licenseType = value;
        this._refresh$.next();
    }

    public licensedFilterList = licensedFilterList();

    public encodeFilters = encodeFilters;

    private _licenseType!: LicenseUrlMapFrontOffice;

    public getRobotType = (type: string) => ROBOT_TYPES.find(t => t.label === type);
}
